// extracted by mini-css-extract-plugin
export default {"grid":"MagasinPage_grid__uQfjp"};